import { isScadColorString } from '../../colorUtils';

export type ColorParseResult = {
  type: 'color';
  value: number[] | string;
};

/**
 * Detects color type for a numeric array value.
 *
 * A 3- or 4-element numeric array is a color when the parameter name or
 * inline comment contains the word "color".
 *
 * Returns null if the condition is not met.
 */
export function parseColorFromArray(
  numElements: number[],
  comment: string,
  name: string,
): ColorParseResult | null {
  if (
    (numElements.length === 3 || numElements.length === 4) &&
    (comment.toLowerCase().includes('color') ||
      name.toLowerCase().includes('color'))
  ) {
    return { type: 'color', value: numElements };
  }
  return null;
}

/**
 * Detects color type for a quoted string value.
 *
 * Returns null if neither the name nor comment contains "color", or if
 * the string is not a recognised SCAD color string.
 */
export function parseColorFromString(
  value: string,
  comment: string,
  name: string,
): ColorParseResult | null {
  if (
    (name.toLowerCase().includes('color') ||
      comment.toLowerCase().includes('color')) &&
    isScadColorString(value)
  ) {
    return { type: 'color', value };
  }
  return null;
}
